import kocLogo from '../../assets/koc-logo-footer.png';
import kocAilemlogo from '../../assets/images/koc-ailem-logo.png';

import { useLocation } from 'react-router-dom';
import Grid from '@mui/material/Grid';

import classes from './styles.module.scss';

const CongratChild = () => {

    const location = useLocation();
    const parentName = location.state?.parentName;

    return (
        <div className={classes.congratsPage}>
            <div className={classes.overlay}>
                <div className={classes.container}>
                    <Grid container spacing={0} direction="column" height="100%" wrap='nowrap'>
                        <Grid item flexGrow={1}>
                            <div className={classes.resultSection}>
                                <img src={kocAilemlogo} className='mb-5' alt='KoçAilem Logo' />
                                <h3>Teşekkürler!</h3>
                                <p>Sevgili, {parentName}</p>
                                <p>Talebin oluşturulmuştur. Evrak doğrulaması sonrasında üyeliğin en kısa sürede başlatılacaktır.</p>
                                <p>Detaylı bilgi için <a href='tel:4440447'>444 0 447</a> KoçAilem Çağrı Merkezi'ni arayabilirsin.</p>
                            </div>
                        </Grid>                        
                        <Grid item>
                            <div className={classes.footer}>
                                <img src={kocLogo} alt='KoçAilem Logo' />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    )
}

export default CongratChild